import { apiSlice } from "../apiSlice";

const API_ORIGIN = new URL(process.env.REACT_APP_SLDL_TESTING_ENVIRONMENT_API_BASE_URL).origin;

export const membersService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // getMembers: builder.mutation({
    //   query: ({ drivingSchoolId }) => {
    //     let url = `${API_ORIGIN}/drivingSchools/${encodeURIComponent(
    //       drivingSchoolId
    //     )}`;

    //     return {
    //       url,
    //       method: "GET",
    //       responseHandler: (response) => response.json(),
    //     };
    //   },
    // }),

    getMembersByStatus: builder.query({
      query: ({ drivingSchoolId, status }) => {
        return {
          url: `${API_ORIGIN}/api/members/getMembersByStatus?drivingSchoolId=${drivingSchoolId}&&status=${status}`,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
      providesTags: ["Members"],
    }),

    getNonMembersUsers: builder.query({
      query: ({ drivingSchoolId }) => {
        return {
          url: `${API_ORIGIN}/api/members/getNonMemberUsers?drivingSchoolId=${drivingSchoolId}`,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
      providesTags: ["Members"],
    }),

    addMemberToDrivingSchool: builder.mutation({
      query: (data) => ({
        url: `${API_ORIGIN}/api/members/addMember`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    updateMembersByStatus: builder.mutation({
      query: (data) => ({
        url: `${API_ORIGIN}/api/members/updateMember`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    updateActiveMembers: builder.mutation({
      query: ({ drivingSchoolId, memberId, data }) => ({
        url: `${API_ORIGIN}/api/members/editActiveMember?drivingSchoolId=${drivingSchoolId}&memberId=${memberId}`,
        method: "PUT",
        body: data,
      }),
    }),

    // updateDrivingSchool: builder.mutation({
    //   query: ({ drivingSchoolId, data }) => ({
    //     url: `${API_ORIGIN}/drivingSchools/${drivingSchoolId}`,
    //     method: "PUT",
    //     body: data,
    //   }),
    // }),

    // deleteDrivingSchool: builder.mutation({
    //   query: ({ drivingSchoolId, data }) => ({
    //     url: `${API_ORIGIN}/drivingSchools/${drivingSchoolId}`,
    //     method: "DELETE",
    //     body: data,
    //   }),
    // }),
  }),
});

export const {
  useGetMembersByStatusQuery,
  useGetNonMembersUsersQuery,
  useAddMemberToDrivingSchoolMutation,
  useUpdateMembersByStatusMutation,
  useUpdateActiveMembersMutation,
} = membersService;
